import React, { useState, useEffect } from 'react';
import '../../App.css';
import { useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select';
import { talentService, locationService } from '../../api/apiService';

const DropdownIndicator = props => (
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <div style={{ width: '16px', margin: '0' }}>
        <svg version="1.1" viewBox="0 0 322.9 257.78" shapeRendering="geometricPrecision">
          <path d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z" />
        </svg>
      </div>
    </components.DropdownIndicator>
  )
);

const selectStyles = {
  dropdownIndicator: (provided) => ({ ...provided, border: 'none' }),
  control: (base) => ({
    ...base,
    width: '500px',
    borderColor: 'black',
    borderWidth: '1px',
    boxShadow: 'none',
    margin: '0px',
    borderRadius: '0px',
    marginBottom: '5px',
    color: 'black',
    fontWeight: '700',
    height: 'auto',
    textTransform: 'uppercase',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  placeholder: (provided) => ({ ...provided, color: 'black', fontWeight: '700' }),
  input: (provided) => ({ ...provided, color: 'black', fontWeight: '700' }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'black' : 'inherit',
    '&:hover': { backgroundColor: state.isSelected ? 'black' : '#f7f7f7' },
  }),
};

const positions = [
  { value: 'Hair & Make-Up', label: 'Hair & Make-Up' },
  { value: 'Art Direktion', label: 'Art Direktion' },
  { value: 'Foto', label: 'Foto' },
  { value: 'Foto Assist', label: 'Foto Assist' },
  { value: 'Video', label: 'Video' },
  { value: 'Digi-OP', label: 'Digi-OP' },
  { value: 'Styling', label: 'Styling' },
  { value: 'Styling Assist', label: 'Styling Assist' },
  { value: 'LOGISTIK / WARENAUFBEREITUNG', label: 'LOGISTIK / WARENAUFBEREITUNG' },
  { value: 'PRODUCER', label: 'PRODUCER' },
  { value: 'Art Buying', label: 'Art Buying' },
  { value: 'Account Management', label: 'Account Management' },
  { value: 'Videoproducing', label: 'Videoproducing' },
  { value: 'AI Content Production', label: 'AI Content Production' },
  { value: 'Development', label: 'Development' },
];

const setOptions = [
  { value: 'On Model', label: 'On Model' },
  { value: 'On Produkt', label: 'On Produkt' },
  { value: 'digital Production', label: 'digital Production' },
];

function AddTalent() {
  const navigate = useNavigate();

  // Basic info
  const [talentName, setTalentName] = useState('');
  const [talentEmail, setTalentEmail] = useState('');
  const [talentPhone, setTalentPhone] = useState('');
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [talentType, setTalentType] = useState(null);
  const [selectLocations, setSelectedLocations] = useState([]);
  const [talentPrice, setTalentPrice] = useState('');
  const [talentWeb, setTalentWeb] = useState('');
  const [talentVerifizierungv, setTalentVerifizierungv] = useState('');
  const [talentNotiz, setTalentNotiz] = useState('');

  // Agency / AP
  const [isAgency, setIsAgency] = useState(false);
  const [agencyBillSeparately, setAgencyBillSeparately] = useState(false);
  const [talentAgentur, setTalentAgentur] = useState('');
  const [talentAP, setTalentAP] = useState('');
  const [lanoid, setLanoid] = useState('');
  const [agencyVatStatus, setAgencyVatStatus] = useState('');
  const [agencyTaxId, setAgencyTaxId] = useState('');
  const [agencyVatId, setAgencyVatId] = useState('');
  const [agencyBankAccount, setAgencyBankAccount] = useState('');
  const [agencyEmail, setAgencyEmail] = useState('');

  // Billing / VAT
  const [vatStatus, setVatStatus] = useState('');
  const [taxId, setTaxId] = useState('');
  const [vatId, setVatId] = useState('');
  const [bankAccount, setBankAccount] = useState('');
  const [country, setCountry] = useState('');
  const [companyName, setCompanyName] = useState('');

  const [locations, setLocations] = useState([]);

  useEffect(() => {
    locationService.getAllLocations(1, 1000)
      .then(response => {
        const data = response?.data?.locations || response?.data || [];
        setLocations(
          data.map(l => l.short).filter(Boolean).sort().map(s => ({ value: s, label: s }))
        );
      })
      .catch(err => {
        console.error('Error fetching locations:', err);
        setLocations(['HH', 'BER', 'MUC', 'CGN', 'FFM'].map(s => ({ value: s, label: s })));
      });
  }, []);

  const resetForm = () => {
    setTalentName(''); setTalentEmail(''); setTalentPhone('');
    setSelectedPosition(null); setTalentType(null); setSelectedLocations([]);
    setTalentPrice(''); setTalentWeb('');
    setTalentVerifizierungv(''); setTalentNotiz('');
    setIsAgency(false); setAgencyBillSeparately(false);
    setTalentAgentur(''); setTalentAP(''); setLanoid('');
    setAgencyVatStatus(''); setAgencyTaxId(''); setAgencyVatId('');
    setAgencyBankAccount(''); setAgencyEmail('');
    setVatStatus(''); setTaxId(''); setVatId('');
    setBankAccount(''); setCountry(''); setCompanyName('');
  };

  const addTalent = async (e) => {
    e.preventDefault();
    try {
      await talentService.createTalent({
        name: talentName,
        email: talentEmail,
        phone: talentPhone,
        function: selectedPosition?.label || '',
        Funktion: selectedPosition?.label || '',
        rate: talentPrice,
        Gage: talentPrice,
        Tagessatz: talentPrice,
        Bereich: talentType?.label || '',
        Web: talentWeb,
        Verifizierung: talentVerifizierungv,
        Notiz_Setcast: talentNotiz,
        locations: selectLocations.map(l => l.value),
        // Agency / AP
        Agentur: talentAgentur,
        AP: talentAP,
        Lano_ID: lanoid || null,
        is_agency: isAgency,
        agency_bill_separately: agencyBillSeparately,
        agency_email: agencyEmail || null,
        agency_vat_status: agencyVatStatus || null,
        agency_tax_id: agencyTaxId || null,
        agency_vat_id: agencyVatId || null,
        agency_bank_account: agencyBankAccount || null,
        // Billing / VAT
        vat_status: vatStatus || null,
        tax_id: taxId || null,
        vat_id: vatId || null,
        bank_account: bankAccount || null,
        country: country || null,
        company_name: companyName || null,
      });
      alert('Talent added successfully.');
      resetForm();
    } catch (error) {
      console.error('Error adding talent:', error);
      alert('Error adding talent: ' + (error.response?.data?.message || error.message));
    }
  };

  const fg = { marginBottom: '12px' };
  const labelStyle = { display: 'block', fontWeight: '700', fontSize: '11px', textTransform: 'uppercase', marginBottom: '3px' };
  const inputStyle = { width: '500px', display: 'block' };
  const hintStyle = { fontSize: '11px', color: '#666', marginTop: '3px', display: 'block', maxWidth: '500px' };
  const h2Style = { marginTop: '30px', marginBottom: '16px', fontSize: '14px', fontWeight: '700', letterSpacing: '0.05em', textTransform: 'uppercase', borderBottom: '1px solid black', paddingBottom: '6px', width: '500px' };
  const checkboxRow = { display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '8px', maxWidth: '500px' };

  return (
    <div className="content-wrapper page">
      <section>
        <h1 style={{ marginBottom: '40px' }}>Talent</h1>
        <h2 style={{ marginBottom: '40px' }}>Add Talent</h2>
        <form onSubmit={addTalent}>

          {/* ── BASIC INFO ── */}
          <h2 style={h2Style}>Basic information</h2>

          <div style={fg}>
            <label style={labelStyle}>Name *</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentName} onChange={e => setTalentName(e.target.value)} required placeholder="First name" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Email *</label>
            <input className="inputtext" style={inputStyle} type="email" value={talentEmail} onChange={e => setTalentEmail(e.target.value)} required placeholder="email@example.com" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Phone</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentPhone} onChange={e => setTalentPhone(e.target.value)} placeholder="+49 …" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Function</label>
            <Select components={{ DropdownIndicator }} options={positions} onChange={setSelectedPosition} placeholder="Function" value={selectedPosition} styles={selectStyles} isClearable />
          </div>
          <div style={fg}>
            <label style={labelStyle}>SET / Bereich</label>
            <Select value={talentType} onChange={setTalentType} options={setOptions} placeholder="SET / Bereich" isClearable styles={selectStyles} />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Locations</label>
            <Select isMulti value={selectLocations} onChange={setSelectedLocations} options={locations} isClearable placeholder="Locations" styles={selectStyles} />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Day rate (€)</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentPrice} onChange={e => setTalentPrice(e.target.value)} placeholder="Price per day" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Website</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentWeb} onChange={e => setTalentWeb(e.target.value)} placeholder="https://…" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Verification</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentVerifizierungv} onChange={e => setTalentVerifizierungv(e.target.value)} placeholder="Verification status" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Notes (SetCast)</label>
            <textarea className="inputtext" style={{ ...inputStyle, height: '80px' }} value={talentNotiz} onChange={e => setTalentNotiz(e.target.value)} placeholder="Internal notes…" />
          </div>

          {/* ── AGENCY / AP ── */}
          <h2 style={h2Style}>Agency / AP</h2>

          <div style={{ ...fg, ...checkboxRow }}>
            <input type="checkbox" checked={isAgency} onChange={e => setIsAgency(e.target.checked)} style={{ marginTop: '2px', width: '16px', height: '16px', cursor: 'pointer', flexShrink: 0 }} />
            <div>
              <span style={{ fontWeight: '700', fontSize: '12px', textTransform: 'uppercase' }}>Is agency</span>
              <span style={hintStyle}>When checked, this talent is treated as an agency: agency info and VAT are used on credit notes. You can bill all in one CN or separately (talent CN + agency provision CN).</span>
            </div>
          </div>

          {isAgency && (
            <div style={{ ...fg, ...checkboxRow }}>
              <input type="checkbox" checked={agencyBillSeparately} onChange={e => setAgencyBillSeparately(e.target.checked)} style={{ marginTop: '2px', width: '16px', height: '16px', cursor: 'pointer', flexShrink: 0 }} />
              <div>
                <span style={{ fontWeight: '700', fontSize: '12px', textTransform: 'uppercase' }}>Bill separately (talent CN + agency provision CN)</span>
                <span style={hintStyle}>When checked: first credit note = talent with talent VAT; second = agency provision (AP %) with agency VAT. When unchecked: one credit note to agency with all lines and agency VAT.</span>
              </div>
            </div>
          )}

          <span style={{ ...hintStyle, marginBottom: '12px', display: 'block' }}>Agency details (name, VAT, bank, etc.) are stored per talent. If several talents use the same agency, fill in on each talent.</span>

          <div style={fg}>
            <label style={labelStyle}>Agentur</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentAgentur} onChange={e => setTalentAgentur(e.target.value)} placeholder="Agency name" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>AP (Ansprechpartner)</label>
            <input className="inputtext" style={inputStyle} type="text" value={talentAP} onChange={e => setTalentAP(e.target.value)} placeholder="Contact person" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Lano ID</label>
            <input className="inputtext" style={inputStyle} type="text" value={lanoid} onChange={e => setLanoid(e.target.value)} placeholder="Lano ID (optional)" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Agency VAT status</label>
            <select name="agency_vat_status" value={agencyVatStatus} onChange={e => setAgencyVatStatus(e.target.value)} style={{ width: '500px', padding: '8px', fontWeight: '700', border: '1px solid black', borderRadius: '0', marginBottom: '5px' }}>
              <option value="">—</option>
              <option value="with_vat">With VAT (19 %)</option>
              <option value="without_vat">Without VAT</option>
            </select>
            <span style={hintStyle}>For agency / divided credit notes. Set "With VAT" when agency charges 19 %.</span>
          </div>
          <div style={fg}>
            <label style={labelStyle}>Agency Tax ID (Steuernummer)</label>
            <input className="inputtext" style={inputStyle} type="text" value={agencyTaxId} onChange={e => setAgencyTaxId(e.target.value)} placeholder="Steuernummer" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Agency VAT ID (USt-ID)</label>
            <input className="inputtext" style={inputStyle} type="text" value={agencyVatId} onChange={e => setAgencyVatId(e.target.value)} placeholder="DE123456789" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Agency bank account (IBAN)</label>
            <textarea className="inputtext" style={{ ...inputStyle, height: '60px' }} value={agencyBankAccount} onChange={e => setAgencyBankAccount(e.target.value)} placeholder="IBAN / bank details" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Agency email</label>
            <input className="inputtext" style={inputStyle} type="email" value={agencyEmail} onChange={e => setAgencyEmail(e.target.value)} placeholder="agency@example.com" />
          </div>

          {/* ── BILLING / VAT ── */}
          <h2 style={h2Style}>Billing / VAT</h2>

          <div style={fg}>
            <label style={labelStyle}>VAT status</label>
            <select name="vat_status" value={vatStatus} onChange={e => setVatStatus(e.target.value)} style={{ width: '500px', padding: '8px', fontWeight: '700', border: '1px solid black', borderRadius: '0', marginBottom: '5px' }}>
              <option value="">—</option>
              <option value="with_vat">With VAT (19 %)</option>
              <option value="without_vat">Without VAT</option>
              <option value="kleinunternehmer">Kleinunternehmer (§19 UStG)</option>
              <option value="auslander">Ausländer (abroad)</option>
            </select>
            <span style={hintStyle}>When talent has no VAT and "Agency VAT status" above is With VAT (and AP is set), two credit notes are created automatically (talent + agency).</span>
          </div>
          <div style={fg}>
            <label style={labelStyle}>Tax ID (Steuernummer)</label>
            <input className="inputtext" style={inputStyle} type="text" value={taxId} onChange={e => setTaxId(e.target.value)} placeholder="Steuernummer" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>VAT ID (USt-ID)</label>
            <input className="inputtext" style={inputStyle} type="text" value={vatId} onChange={e => setVatId(e.target.value)} placeholder="DE123456789" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Bank account (IBAN)</label>
            <textarea className="inputtext" style={{ ...inputStyle, height: '60px' }} value={bankAccount} onChange={e => setBankAccount(e.target.value)} placeholder="IBAN / bank details" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Country</label>
            <input className="inputtext" style={inputStyle} type="text" value={country} onChange={e => setCountry(e.target.value)} placeholder="e.g. Germany" />
          </div>
          <div style={fg}>
            <label style={labelStyle}>Company name (Rechnungsname)</label>
            <input className="inputtext" style={inputStyle} type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} placeholder="Company / billing name" />
          </div>

          <button style={{ marginTop: '30px' }} className="big-button" type="submit">Add Talent</button>
        </form>
      </section>
    </div>
  );
}

export default AddTalent;
